module.exports = __webpack_public_path__ + "img/2-3.52960380.jpg";